export default __webpack_public_path__ + "static/media/diapason.506e2e5f.png";